import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: ${theme.palette.lightBlue.main};
    border-color: ${theme.palette.lightBlue.main};
    border-radius: 0.4rem;
    padding: 0.5rem 0.75rem;
    width: 100%;
`;
